<template>
    <div id="app-layout">
        <app-header></app-header>
        <div class="container py-2" v-if="!isMessageConfirmed">
            <div class="row">
                <div class="col-12">
                    <div class="alert alert-warning my-0 text-center">
                        <p v-html="$t('new_account_required_message')" />
                        <p class="text-bold" v-html="$t('new_account_required_message_2')" />
                        <button class="btn btn-primary btn-sm ml-2 d-inline" @click="confirmMessage" v-text="$t('new_account_required_confirmation')" />
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import AppHeader from '@components/AppHeader';

    export default {
        components: {
            AppHeader,
        },
        data() {
            return {
                isMessageConfirmed: false,
            };
        },
        created() {
            // Check if the message has already been confirmed
            this.isMessageConfirmed = localStorage.getItem('newSystemMessageConfirmed') === 'true';
        },
        methods: {
            confirmMessage() {
                // Mark the message as confirmed
                this.isMessageConfirmed = true;
                localStorage.setItem('newSystemMessageConfirmed', 'true');
            },
        },
    };
</script>

<style scoped>
    .alert {
        margin: 20px;
        padding: 15px;
        border: 1px solid #f0ad4e;
        background-color: #fcf8e3;
        color: #8a6d3b;
        border-radius: 5px;
    }
    .text-bold{
        font-weight: bold;
    }
</style>
